import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
  InspectionAlarmtCase,
  ShutdownPumpDetailsCheck
} from '@authority-labs/api-interfaces';

@Component({
  selector: 'authority-labs-check-shutdown-pump-details-case',
  templateUrl: './check-shutdown-pump-details-case.html',
  styleUrls: ['./check-shutdown-pump-details-case.scss']
})
export class CheckShutdownPumpDetailsCaseComponent {
  @Input() shutdownPumpDetails: ShutdownPumpDetailsCheck;
  @Input() readonly: boolean;
  @Input() printPreview: boolean;
  @Input() fieldSection: string;
  @Output() dataChange: EventEmitter<void> = new EventEmitter();

  selectedTab = 0;
  // plumberRoomWaterSupplyCharacteristics: MeasureType[] = [
  //   MeasureType.StaticPressure,
  //   MeasureType.ResidualPressure,
  //   MeasureType.FlowRate
  // ];

  // tabName is now handled directly in the template via transloco

  addPump(): void {
    this.shutdownPumpDetails.testData.push(new InspectionAlarmtCase());
    this.selectedTab = this.shutdownPumpDetails.testData.length - 1;
    this.onDataChange();
  }

  removePump(index: number): void {
    this.shutdownPumpDetails.testData.splice(index, 1);
    this.onDataChange();
  }

  onDataChange(): void {
    this.dataChange.emit();
  }
}
